import { ApiDocs } from '../../components/docs/ApiDocs';
import { apiFetch, VIDEO_API_BASE } from '../../utils/api';

/**
 * The 360 app's integration reference, rendered from the spec it serves itself.
 * See {@link ../../components/docs/ApiDocs.ApiDocs}.
 */
const fetchSpec = (path: string) => apiFetch(path, { app: 'video' });

export function VideoDocsPage() {
  return <ApiDocs apiBase={VIDEO_API_BASE} fetchSpec={fetchSpec} />;
}
